/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementFbInstantInterstitialOptions, FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSON, } from './FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions';
export function FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementFbInstantInterstitialOptions(json)) {
        return FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementFbInstantInterstitialOptions(value)) {
        return FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial.js.map